// Campus photo for /colleges/university-of-california-davis: CC BY 4.0, by KMashian, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMrak_Hall_(UC_Davis)_Across_Lake_Spafford.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-davis/; credited under the photo.
const photo = {
    "slug": "university-of-california-davis",
    "alt": "Mrak Hall seen across Lake Spafford in the Arboretum at UC Davis in Davis, California",
    "src": "/colleges/university-of-california-davis/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-davis/campus-800.webp",
    "srcMid": "/colleges/university-of-california-davis/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-davis/og.jpg",
    "title": "Mrak Hall (UC Davis) Across Lake Spafford",
    "author": "KMashian",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMrak_Hall_(UC_Davis)_Across_Lake_Spafford.jpg",
    "read": "2026-09-30"
};

export default photo;
